import { z } from 'zod';
/**
 * Журнал событий — единственный способ, которым клиент меняет данные.
 * События append-only: ошибочное не удаляется и не правится,
 * администратор создаёт компенсирующее событие CORRECTION с обязательной причиной.
 *
 * id генерируется НА КЛИЕНТЕ → повторная отправка идемпотентна.
 */
export const EVENT_TYPES = [
    /**
     * Диагностическое событие: «проверка связи». Не порождает никаких данных,
     * нужно чтобы проверить прохождение очереди с реального устройства в цеху.
     */
    'SYNC_TEST',
    // Сменные отчёты
    'SHIFT_REPORT_SUBMITTED',
    'SHIFT_REPORT_CORRECTED',
    'SHIFT_REPORT_ACCEPTED',
    'PHOTO_ATTACHED',
    // Склад
    'MATERIAL_RECEIPT_RECORDED',
    'INVENTORY_COUNT_RECORDED',
    'SHIPMENT_RECORDED',
    // График смен
    'WISH_COLLECTION_STARTED',
    'DAYOFF_WISH_SUBMITTED',
    'SCHEDULE_DRAFT_UPDATED',
    'SCHEDULE_PUBLISHED',
    'SCHEDULE_CHANGED',
    'ABSENCE_REQUESTED',
    'ABSENCE_REPORTED_UNPLANNED',
    'ABSENCE_DECIDED',
    // Найм
    'CANDIDATE_CREATED',
    'CANDIDATE_CALL_LOGGED',
    'CANDIDATE_COMMENT_ADDED',
    'CANDIDATE_APPOINTMENT_SCHEDULED',
    'CANDIDATE_ATTENDANCE_MARKED',
    'CANDIDATE_INTERNSHIP_RESULT_RECORDED',
    'CANDIDATE_HIRED',
    'CANDIDATE_ERASED',
];
export const eventTypeSchema = z.enum(EVENT_TYPES);
/** Максимум событий в одной пачке POST /api/sync/push. */
export const MAX_PUSH_BATCH = 50;
export const domainEventSchema = z
    .object({
    /** UUID v4, сгенерированный на устройстве. Ключ идемпотентности. */
    id: z.string().uuid(),
    type: eventTypeSchema,
    aggregateType: z.string().min(1).max(64),
    aggregateId: z.string().min(1).max(64),
    userId: z.string().uuid(),
    deviceId: z.string().min(1).max(64),
    payload: z.record(z.unknown()),
    schemaVersion: z.number().int().positive().default(1),
    /** Время НА УСТРОЙСТВЕ в момент нажатия. Сервер его не подменяет. */
    occurredAt: z.string().datetime({ offset: true }),
    /** Ссылка на исправляемое событие — только для корректировок. */
    correctsEventId: z.string().uuid().nullish(),
    /** Причина корректировки. Обязательна, если указан correctsEventId. */
    correctionReason: z.string().trim().min(3).max(1000).nullish(),
})
    .superRefine((event, ctx) => {
    if (event.correctsEventId && !event.correctionReason) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['correctionReason'],
            message: 'Для корректировки обязательно указать причину',
        });
    }
});
export const syncPushRequestSchema = z.object({
    events: z.array(domainEventSchema).min(1).max(MAX_PUSH_BATCH),
});
/** Причина отказа. Отклонённые события НЕ удаляются молча — оператор их видит. */
export const eventRejectionSchema = z.object({
    id: z.string(),
    reason: z.string(),
});
export const syncPushResponseSchema = z.object({
    /** Приняты или уже были приняты раньше (повтор — не ошибка). */
    accepted: z.array(z.string()),
    rejected: z.array(eventRejectionSchema),
    serverTime: z.string(),
});
//# sourceMappingURL=events.js.map